import { AssetApi, EnrichedAssetApi } from '../api/models';

export class Asset
{
    assetId: string;
    entityId: string;
    identifier: string;
    assetName: string;
    typeName: string;

    public static mapperFromApi (source: AssetApi): Asset
    {
        const target = new Asset();

        Object.assign(target, source);

        return target;
    }
}

export class EnrichedAsset
{
    assetId: string;
    identifier: string;
    assetName: string;
    tagIds: string[];

    public static mapperFromApi (source: EnrichedAssetApi): EnrichedAsset
    {
        const target = new EnrichedAsset();

        Object.assign(target, source);

        return target;
    }
}
